export default {"src":"/_next/static/media/mail_icon.ff7a4928.svg","height":19,"width":24,"blurWidth":0,"blurHeight":0};